<template>
  <div class="mt-200">
    <h3 class="text-uppercase mb-100">Change Password</h3>

    <form-field-password
      label="Current Password"
      v-model="form.old_password"
      :validation-errors="validationErrors.old_password"
    ></form-field-password>

    <form-field-password
      label="New Password"
      v-model="form.new_password"
      :validation-errors="validationErrors.new_password"
    ></form-field-password>

    <form-field-password
      label="Confirm Password"
      v-model="form.new_password_confirmation"
      :validation-errors="validationErrors.new_password_confirmation"
    ></form-field-password>

    <div class="flex flex-end mt-100">
      <button-default
        :loading="isSaving"
        @click="save"
      >
        Save
      </button-default>
    </div>
  </div>
</template>

<script>
import localStorageService from "../../../services/localStorage";
import {FormMixin} from "../../../forms/forms.mixin";

export default {
  name: 'ProfileChangePassword',
  mixins: [FormMixin],
  data() {
    return {
      isSaving: false,
      validationErrors: {},
      form: {},
      defaultForm: {
        id: localStorageService.getAuthUser().id,
        old_password: '',
        new_password: '',
        new_password_confirmation: ''
      },
    }
  },
  mounted() {
    this.initForm()
  },
  methods: {
    initForm() {
      this.form = this.$utils.clone(this.defaultForm);
    },
    update() {
      return this.$api.users.updatePassword(this.form)
        .then((res) => {
          this.initForm()
          localStorageService.setApiToken(res.data.api_token);

          this.$buefy.toast.open({
            message: "Your password has been changed",
            type: 'is-success'
          });

          return res;
        })
    }
  }
}
</script>
